import { render, staticRenderFns } from "./ArrowVertical.vue?vue&type=template&id=6123e8e6"
import script from "./ArrowVertical.vue?vue&type=script&lang=js"
export * from "./ArrowVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports